export enum EventType {
  All,
  In,
  Out,
}
